import axios from "axios";
import ReportModel from "../models/report.model";
import Globals from "../api/globals";
import {
  formatDateToMM,
  formatDateToYYYY,
  formatDateToYYYYMM,
  formatDateToYYYYMMDD,
} from "../functions/date-format";

export default class ReportService {
  private static _instance: ReportService | null = null;

  private constructor() {}

  static getInstance(): ReportService {
    if (!ReportService._instance) {
      ReportService._instance = new ReportService();
    }
    return ReportService._instance;
  }

  async getReportOfVisit(visitId: number): Promise<ReportModel> {
    const token = localStorage.getItem("token");

    const response = await axios.get(`${Globals.apiUrl}/rapports`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        publicationState: "preview",
        filters: {
          visit: {
            id: { $eq: visitId },
          },
        },
        populate: {
          products: {
            populate: ["product"],
          },
          coproducts: {
            populate: ["coproduct"],
          },
          suppliers: {
            populate: ["supplier"],
          },
          comments: {
            populate: ["comment"],
          },
          engaged_products: {
            populate: "*",
          },
          Products_per_patient: {
            populate: "*",
          },
        },
      },
    });


    if (response.status === 200 && response.data.data.length > 0) {
      return ReportModel.fromJson(response.data.data[0]);
    }

    return new ReportModel();
  }

  async getReportOfClient(clientId: number, date: Date): Promise<ReportModel> {
    const token = localStorage.getItem("token");
    var response = await axios.get(
      `${
        Globals.apiUrl
      }/rapports?publicationState=preview&filters[visit][client][id][$eq]=${clientId}&filters[visit][createdDate][$lte]=${formatDateToYYYYMMDD(
        date
      )}&filters[visit][createdDate][$gte]=${formatDateToYYYYMMDD(
        date
      )}&populate=products.product&populate=coproducts.coproduct&populate=suppliers.supplier&populate=comments.comment`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status == 200 && response.data.data.length > 0) {
      var report = ReportModel.fromJson(response.data["data"][0]);
      return report;
    }
    return new ReportModel();
  }

  async updateReport(reportId: number, data: any): Promise<boolean> {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.put(
        `${Globals.apiUrl}/rapports/${reportId}`,
        {
          data: data,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.status === 200;
    } catch (error) {
      console.error("Update report error:", error);
      return false;
    }
  }
}
